import {
  Box, Icon, IconName, Text,
} from '@usealloy/component-library';
import React from 'react';


interface TipCalloutProps {
  iconName?: IconName;
  highlightColor?: string;
  text: string | React.ReactNode;
  highlighted?: boolean;
  className?: string;
  style?: React.CSSProperties;
}
export default function TipCallout({
  iconName = IconName.LightbulbHint,
  highlightColor = 'var(--cl-yellow-600)',
  text,
  highlighted = false,
  className,
  style,
}: TipCalloutProps) {
  return (
    <Box
      className={className}
      style={{
        ...(highlighted && { backgroundColor: highlightColor }),
        ...style,
      }}
    >
      <div
        style={{
          width: 24,
        }}
      >
        <Icon
          icon={iconName}
        />
      </div>
      <Text
        size={1}
        style={{
          color: 'var(--cl-gray-700)',
        }}
      >{text}
      </Text>
    </Box>
  );
}
